import { shareWithOptions as options } from "ExtendedFields/ExtendedFieldsProvider";
import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";

import FnrCard from "UI/FnrCard/FnrCard";
import { FnrRadioButtonOption } from "UI/FnrRadioButtonOption";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

const ShareWith = () => {
  const [shareWith, setShareWith] = extendedFieldHooks.useShareWith();
  const isReadOnly = extendedFieldHooks.useIsReadOnly();

  return (
    <FnrCard data-cy="ExtendedFields_ShareWith">
      <FnrVerticalGap>
        <FnrTypography>
          Should this field be shared across multiple users?
        </FnrTypography>
        <FnrHorizontalGap gap={24}>
          <FnrRadioButtonOption
            disabled={isReadOnly}
            isActive={shareWith === options.user}
            onClick={() => setShareWith(options.user)}
            noMargin
          >
            <span>No</span>
          </FnrRadioButtonOption>
          <FnrRadioButtonOption
            isActive={shareWith === options.household}
            onClick={() => setShareWith(options.household)}
            noMargin
            disabled={isReadOnly}
          >
            <span>Within a Household</span>
          </FnrRadioButtonOption>
          <FnrRadioButtonOption
            isActive={shareWith === options.spouse}
            onClick={() => setShareWith(options.spouse)}
            noMargin
            disabled={isReadOnly}
          >
            <span>Between Spouses</span>
          </FnrRadioButtonOption>
        </FnrHorizontalGap>
      </FnrVerticalGap>
    </FnrCard>
  );
};

export default ShareWith;
